export default {
  setOrgTypes(state, data){
    state.orgTypes = data;
  },
  setOrgData(state, data) {
    state.orgData = data;
  },
  setOrgList(state, data) {
    state.orgList = data;
  }
}